async function newHandleAddGiftAndReload(ruleId) {
        const selectedGiftMap = window.tlAdvancedFreeGift.ruleIdMapSelectedGift.get(ruleId);
        if (!selectedGiftMap || Object.keys(selectedGiftMap).length === 0) return;

        window.tlAdvancedFreeGift.loadingWhenClaim();

        const handleError = async (response) => {
            const { description } = await response.json();
            window.tlAdvancedFreeGift.showError(ruleId, description);
            window.tlAdvancedFreeGift.removeLoading();
        };

        const removeResponse = await window.tlAdvancedFreeGift.removeUnselectedGifts([ruleId]);
        if (removeResponse && !removeResponse.ok) {
            await handleError(removeResponse);
            return;
        }

        const addResponse = await window.tlAdvancedFreeGift.handleAddGift([ruleId]);
        if (addResponse.status !== 200) {
            await handleError(addResponse);
            return;
        }

        if (!window.TLCustomEventGiftsAdvanced) {
            await tlPopupCartReRender();
            window.tlAdvancedFreeGift.ruleIdMapSelectedGift.set(ruleId, {});
            window.tlAdvancedFreeGift.handleToggle();
            window.tlAdvancedFreeGift.removeLoading();
            window.location.href = '/cart';
            // return;
        }

        if (window.TLCustomEventGiftsAdvanced === 1) {
            window.dispatchEvent(new CustomEvent("TLCustomEvent:FreeGiftsAdvanced-handleAddGiftAndReload"));
        }
}
const intervalIdSalepify = setInterval(() => {
    if (window.tlAdvancedFreeGift) {
        clearInterval(intervalIdSalepify);
        window.tlAdvancedFreeGift.handleAddGiftAndReload = newHandleAddGiftAndReload;
        console.log("custom advanced FG salepify done");
    }
}, 100);

setTimeout(() => {
    clearInterval(intervalIdSalepify);
}, 3000)